import React from 'react';
import { connect } from 'react-redux';
// Popup imports
import { UpdatePopupProps } from '../../../../actions/popupActions';
import { PopupTypes } from '../../Enums';
import LevelSettingsModeEnum from './enums';
import Header from './header';
// Game(kit) imports
import gameKit from '../../../../../GameKit';
import RangeSlider from '../../../Default/RangeSlider/index';
import { DefaultLevelSettings, GameGoalFlag } from '../../../../../Game/Enums';
import settings from '../../../../../settings';

class LevelSettingsGoal extends React.Component {
    handleChangeDescription = event => {
        const { levelUuid } = this.props;
        const newDescription = event.target.value;
        gameKit.updateLevelSettings(levelUuid, { description: newDescription });
    };

    handleTimeChange = timeLimit => {
        const { levelUuid } = this.props;
        gameKit.updateLevelSettings(levelUuid, { timeLimit });
    };

    handlePointsChange = pointsGoal => {
        const { levelUuid } = this.props;
        gameKit.updateLevelSettings(levelUuid, { pointsGoal: pointsGoal > 0 ? pointsGoal : 1 });
    };

    handleBack = () => {
        const { dispatch, fromLevelGrid, levelUuid } = this.props;
        dispatch(
            UpdatePopupProps(PopupTypes.LEVEL_SETTINGS, {
                mode: LevelSettingsModeEnum.MAIN,
                fromLevelGrid,
                levelUuid
            })
        );
    };

    Sliders = () => {
        const { levelSettings, game } = this.props;

        return (
            <>
                {game.goal & GameGoalFlag.TIME_LIMIT ? (
                    <div className="level-goal-slider time-slider">
                        <span className="prefix">Tijdlimiet</span>
                        <img src={`${settings.assetsPath}img/icons/klock.png`} alt="Level doel: Tijdlimiet" />
                        <RangeSlider
                            description={timeLimit => {
                                const mins = Math.floor(timeLimit / 60.0);
                                const secs = timeLimit % 60;
                                const levelTime = `${mins < 10 ? `0${mins}` : mins}:${secs < 10 ? `0${secs}` : secs}`;
                                return `${levelTime}`;
                            }}
                            step={DefaultLevelSettings.timeLimitStep}
                            sliderStep={DefaultLevelSettings.timeLimitRangeSliderStep}
                            min={DefaultLevelSettings.timeLimitMin}
                            minDisplay="00:10"
                            max={DefaultLevelSettings.timeLimitMax}
                            maxDisplay="10:00"
                            currentValue={levelSettings.timeLimit}
                            onChange={this.handleTimeChange}
                        />
                    </div>
                ) : (
                    <></>
                )}
                {game.goal & GameGoalFlag.POINT_LIMIT ? (
                    <div className="level-goal-slider points-slider">
                        <span className="prefix">Punten</span>
                        <img src={`${settings.assetsPath}img/icons/muntje.png`} alt="Level doel: Punten" />
                        <RangeSlider
                            description={v => `${v}`}
                            step={1}
                            sliderStep={10}
                            min={0}
                            minDisplay={DefaultLevelSettings.pointsGoalMin}
                            max={DefaultLevelSettings.pointsGoalMax}
                            currentValue={levelSettings.pointsGoal}
                            onChange={this.handlePointsChange}
                        />
                    </div>
                ) : (
                    <></>
                )}
            </>
        );
    };

    render = () => {
        const { levelSettings } = this.props;

        return (
            <div id="level-settings-goal">
                <Header />
                <div className="level-settings-goal-content">
                    <span className="input-label">Vertel de speler wat te doen</span>
                    <textarea placeholder="Het doel van je level" value={levelSettings.description} onChange={this.handleChangeDescription} />
                    <div className="sliders-container">
                        <this.Sliders />
                    </div>
                    <div className="padding" />
                    <button className="btn-back" type="button" onClick={this.handleBack}>
                        terug
                    </button>
                </div>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelSettings: state.levelSettings,
    game: state.game
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelSettingsGoal);
